module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp13_8004.ac0947ee.png";